import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';

import Home from './pages/Home';
import About from './pages/About';
import Archive from './pages/Archive';
import Auth from './pages/Auth';
import NotFound from './pages/NotFound';
import PostDetail from './pages/PostDetail';
import WritePost from './pages/WritePost';

function App() {
  // 新增：初始化主题（页面加载时执行）
  useEffect(() => {
    // 1. 读取localStorage中的主题设置
    const savedTheme = localStorage.getItem('theme');
    // 2. 如果没有保存的主题，检测系统偏好
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const initialTheme = savedTheme || (prefersDark ? 'dark' : 'light');
    
    // 3. 应用主题到根元素
    if (initialTheme === 'dark') {
      document.documentElement.classList.add('dark-mode');
    } else {
      document.documentElement.classList.remove('dark-mode');
    }
  }, []);

  return (
    <Router>
      <div className="App">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/archive" element={<Archive />} />
            <Route path="/auth/*" element={<Auth />} />
            <Route path="/post/:id" element={<PostDetail />} />
            <Route path="/write" element={<WritePost />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;